<template>
  <div class="container">
    <div class="tipimport" ref="btnList">
      <div class="rowRight">
        <el-form label-width="80px" class="glo_formBox">

        </el-form>
        <div class="filenames">{{ fileName1 }}</div>
        <div v-if="fileName1">
          <i v-if="!isFileSuccess_1" class="el-icon-loading"></i>
          <i v-else style="color: #00c297" class="el-icon-success"></i>
        </div>
        <el-button class="btns" @click="uploadMaterial(1)">选择文件</el-button>
        <el-button class="btns" @click="goDetails">预览Excel</el-button>
        <el-button class="btns glo_bgcMainColor" @click="saveBtns"
          >确认导入</el-button
        >
      </div>
      <!-- <el-button class="btns" @click="ResetBtns">重置</el-button> -->
      <el-button class="btns glo_bgcMainColor" @click="downTemplate()"
        >下载外发单模板</el-button
      >
      <!-- 上传 -->
    </div>

    <!-- 预览 -->
    <!-- 表格 -->
    <div class="glo_Table">
      <!-- 运单信息 -->
      <div class="tablerTitle">外发单信息</div>
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <!-- <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
        ></el-table-column>-->
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item.field == 'isError' && item.isShow"
          >
            <template slot-scope="scope">
              <div class="errorClaaa" v-if="scope.row.isError == 1">是</div>
              <div v-else>否</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item.field == 'errorReason' && item.isShow"
          >
            <template slot-scope="scope">
              <div class="errorClaaa">{{ scope.row.errorReason }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
            <el-table-column
              v-for="(item2, idx2) in item.childLists"
              :key="idx2"
              :label="item2.name"
              :prop="item2.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item2.width"
              :data-isTotal="item2.isTotal"
            ></el-table-column>
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="120px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                @click.stop="editBtns(scope.row, scope.$index)"
                >修改</el-button
              >
              <el-button
                class="rbtns"
                @click.stop="delBtns(scope.row, scope.$index)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 上传组件 -->
    <input
      type="file"
      style="display: none"
      ref="file"
      @click="
        (e) => {
          e.target.value = '';
        }
      "
      @change="getFileData"
    />

    <!-- 上传运单模板 才用到   fileNameId -->
    <div v-if="isUpload">
      <div>上传运单模板</div>
      <uploadimgs
        @input="changeFileList"
        :fileNameLists="fileNameLists"
        :limit="1"
      ></uploadimgs>
    </div>

    <!-- 弹窗 修改运单 -->
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1('dialogFormRef1')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog1"
          ref="dialogFormRef1"
          :model="dialogForm1"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item class="dialogFormItems queryItems" label="是否报错:">
            <el-select
              clearable
              filterable
              v-model="dialogForm1.isError"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="item in isErrorList"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="dialogForm1.isError == 1"
            class="dislogFormTextarea"
            prop="errorReason"
            label="错误原因:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm1.errorReason"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="waybillNumber"
            label="*运单号:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.waybillNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="outgoingNumber"
            label="*承运单号:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.outgoingNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="allCarrierWeigh"
            label="承运商重量:"
          >
            <el-input type="text" v-model="dialogForm1.allCarrierWeigh"></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="allCarrierVolume"
            label="承运商体积:"
          >
            <el-input type="text" v-model="dialogForm1.allCarrierVolume"></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="allCarrierCount"
            label="承运商件数:"
          >
            <el-input type="text" v-model="dialogForm1.allCarrierCount"></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="formulaWaybillFeeMethod"
            label="*计算方式:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.formulaWaybillFeeMethod"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="unitPrice"
            label="单价:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.unitPrice"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="settlementMethod"
            label="*结算方式:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.settlementMethod"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="dialogFormItems"
              prop="formulaBillingWeight"
              label="分摊方式:"
          >
            <el-input
                type="text"
                v-model="dialogForm1.formulaBillingWeight"
            ></el-input>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="basicFreight"
            label="运费:"
          >
            <el-input type="text" v-model="dialogForm1.basicFreight"></el-input>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="sendFee"
            label="送货费:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.sendFee"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="allOtherFee"
            label="其他费用:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.allOtherFee"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="carrierAttribute"
            label="*承运商属性:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.carrierAttribute"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="carrierName"
            label="*外发承运商:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.carrierName"
            ></el-input>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="carrierPhone"
            label="*承运商电话:"
          >
            <el-input type="text" v-model="dialogForm1.carrierPhone"></el-input>
          </el-form-item>

          <el-form-item
            class="dialogFormItems"
            prop="carrierDept"
            label="*承运商网点:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.carrierDept"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="remarks"
            label="备注:"
          >
            <el-input
              type="text"
              v-model="dialogForm1.remarks"
            ></el-input>
          </el-form-item>

        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
import myDialog from "@/components/Dialog.vue";
import tools from "@/assets/js/tool";
export default {
  components: {
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      customerId: "",
      customerName: "",
      CustomerLists: [], //客户列表
      listType: "text",
      fileName1: "",
      fileName2: "",

      isFileSuccess_1: false,
      isFileSuccess_2: false,
      itemFile: "",
      waybillFile: "",

      isShowYL: false, //是否预览
      isUpload: false,
      // 预览的
      tableHeigth: "75vh",
      myTableHeard: [
        // {
        //   name: "行号",
        //   field: "rowNo",
        //   width: "60",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: true,
        //   childLists: [],
        // },
        {
          name: "是否错误",
          field: "isError",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "错误原因",
          field: "errorReason",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*运单号",
          field: "waybillNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*承运单号",
          field: "outgoingNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "承运商重量",
          field: "allCarrierWeigh",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "承运商体积",
          field: "allCarrierVolume",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "承运商件数",
          field: "allCarrierCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*计算方式",
          field: "formulaWaybillFeeMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "单价",
          field: "unitPrice",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*结算方式",
          field: "settlementMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "分摊方式",
          field: "formulaBillingWeight",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*运费",
          field: "basicFreight",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "送货费",
          field: "sendFee",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "其他费用",
          field: "allOtherFee",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*承运商属性",
          field: "carrierAttribute",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*外发承运商",
          field: "carrierName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*承运商电话",
          field: "carrierPhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "*承运商网点",
          field: "carrierDept",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        },
        {
          name: "备注",
          field: "remarks",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          childLists: [],
        }


      ],

      tableData: [],
      totalArr: [],

      // 弹窗1
      diaWidth1: "80%",
      dialogTitle1: "修改外发单信息",
      isShowDialog1: false,
      dialogForm1: {
        isError: "",
        errorReason: "",
        waybillNumber: "",
        splitWaybillId: "",
        outgoingNumber: "",
        allCarrierWeigh: "",
        allCarrierVolume: "",
        allCarrierCount: "",
        formulaWaybillFeeMethod: "",
        formulaWaybillFeeMethodKey: "",
        unitPrice: "",
        settlementMethod: "",
        settlementMethodConfDictId: "",
        formulaBillingWeight: "",
        formulaBillingWeightId: "",
        basicFreight: "",
        sendFee: "",
        allOtherFee: "",
        carrierAttribute: "",
        carrierAttributeConfDictId: "",
        carrierName: "",
        carrierId: "",
        carrierPhone: "",
        carrierDept: "",
        carrierDeptId: "",
        remarks: "",

      },
      idx1: null,
      // 弹窗2
      diaWidth2: "80%",
      dialogTitle2: "修改运单货物信息",
      isShowDialog2: false,
      dialogForm2: {},
      idx2: null,

      isErrorList: [
        {
          val: 1,
          name: "是",
        },
        {
          val: 0,
          name: "否",
        },
      ],

      groupName: "yuDanMuBan",
      templateName: "外发单导入模板.xlsx",
      // fileNameId: "c379ef3d2745da3620862196bb7b675a.xlsx", //文件id
      fileNameId: "37e4539a5663118c58c082870dfe8c48.xlsx", //文件id
      fileNameLists: [],
      rules: {
        transportMethod: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],

      },
    };
  },
  watch: {},
  created() {
    // let EnterpriseNo = tools.getEnterpriseNo();
    //这里缺一个接口,应该要根据接口拿  fileNameId
    // if (EnterpriseNo == "rx_01") {
    //   this.fileNameId = "c379ef3d2745da3620862196bb7b675a.xlsx";
    // } else if (EnterpriseNo == "bami") {
    //   this.fileNameId = "c379ef3d2745da3620862196bb7b675a.xlsx";
    // }
  },
  mounted() {
    this.fetTableHeight();
  },
  activated() {},
  destroyed() {},
  methods: {

    // 选择图片
    changeFileList(array) {
      console.log("array", array);
      this.fileNameLists = array;
      let fileName = array[0].name || "";
      this.fileNameId = fileName;
      this.$API
        .saveExportTemplate({
          groupName: this.groupName || "",
          templateName: this.templateName || "",
          fileName: fileName || "",
        })
        .then((res) => {
          this.$message.success(res.data.message || "上传成功");
        });
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
      let fileName = array[0].name || "";
      this.$API
        .saveExportTemplate({
          groupName: this.groupName2 || "",
          templateName: this.templateName2 || "",
          fileName: fileName || this.fileNameId2,
        })
        .then((res) => {
          this.$message.success(res.data.message || "上传成功");
        });
    },

    downTemplate() {
      this.$API
          .exportOutgoingModel({})
          .then((res) => {
            let data = res.data;
            // 获取响应的文件流数据
            const blob = new Blob([data], { type: "application/vnd.ms-excel" });
            let url = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.href = url;
            link.download = "外发单导入模板" + ".xlsx"; // 设置下载文件名
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url); // 撤销URL对象
          });
    },

    downLoadYD(type) {
      let fileNames = "";
      let templateName = "";
      if (type == 1) {
        // 下载运单模板
        fileNames = this.fileNameId;
        templateName = this.templateName;
        // let EnterpriseNo = tools.getEnterpriseNo() || '';
        // if (EnterpriseNo === "601") {
        //   this.fileNameId = "c379ef3d2745da3620862196bb7b675a.xlsx";
        //   this.templateName = "运单导入模板.xlsx";
        // } else if (EnterpriseNo === "hs01") {
        //   this.fileNameId = "c379ef3d2745da3620862196bb7b675a.xlsx";
        //   this.templateName = "运单导入模板.xlsx";
        // }
      } else {
        fileNames = this.fileNameId2;
        templateName = this.templateName2;
      }

      this.$API.wtl_getFileUrl({ fileName: fileNames }).then((res) => {
        console.log(res);

        let downloadurl = res.data.result.url;
        var a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadurl;
        a.target = "_blank";
        a.setAttribute("download", templateName); //指定下载后的文件名，防跳转
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },

    editBtns(row, idx) {
      this.isShowDialog1 = true;
      this.dialogForm1 = JSON.parse(JSON.stringify(row));
      this.idx1 = idx;
    },

    delBtns(row, idx) {
      this.$confirm(
        "确定删除该条数据吗? 运单号为: " + row.waybillNumber,
        "提示:"
      )
        .then((res) => {
          let d = JSON.parse(JSON.stringify(this.tableData));
          d.splice(idx, 1);
          this.tableData = d;
        })
        .catch(() => {});
    },
    editBtns2(row, idx) {
      this.isShowDialog2 = true;
      this.dialogForm2 = JSON.parse(JSON.stringify(row));
      this.idx2 = idx;
    },

    delBtns2(row, idx) {
      this.$confirm(
        "确定删除该条数据吗? 运单号为: " + row.waybillNumber,
        "提示:"
      )
        .then((res) => {
          let d = JSON.parse(JSON.stringify(this.tableData2));
          d.splice(idx, 1);
          this.tableData2 = d;
        })
        .catch(() => {});
    },

    goDetails() {
      if (!this.waybillFile) {
        this.$message.error("请上传外发单模板");
        return false;
      }
      const form = new FormData(); //  根据后台需求数据格式
      // form.append("itemFile", this.itemFile); //  文件对象
      form.append("waybillFile", this.waybillFile); //
      this.$showLoading();
      this.$API.importOutgoingV4(form).then((res) => {
        this.$hideLoading();
        let datas = res.data.result || "";
        if (datas) {
          this.tableData = datas; //运单信息
          // this.tableData2 = datas.waybillItemInfoList || []; //货物信息
        }
        this.isShowYL = true;
      });
    },

    // 重置
    ResetBtns() {
      this.fileName1 = "";
      this.fileName2 = "";
      this.isFileSuccess_1 = false;
      this.isFileSuccess_2 = false;
      this.itemFile = "";
      this.waybillFile = "";
    },

    //  上传
    uploadMaterial(type) {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    // 触发上传材料文件
    getFileData() {
      const inputFile = this.$refs.file.files[0];

      const file = inputFile;
      const fileName = inputFile.name;

      this.isFileSuccess_1 = true;
      this.fileName1 = fileName;
      this.waybillFile = file;
    },

    // 预览部分的

    // 确定导入
    saveBtns() {
      if(!this.tableData||this.tableData.length < 1)
        this.$message.warning("暂无数据,请先导入Excel数据");
      let chartsArray = this.tableData.filter((item) => item.errorReason) || [];
      console.log("chartsArray", chartsArray);
      if (chartsArray.length > 0) {
        this.$message.warning("还存在错误的数据,请修改完后重新提交");
        return false;
      }
      this.$API
        .importOutgoingSureV4({
          outgoingList: this.tableData,
          // waybillItemInfoList: this.tableData2,
        })
        .then((res) => {
          let datas = res.data.result || "";
          console.log("res", datas);
          if (datas) {
            this.tableData = datas.outgoingList || []; //运单信息
            // this.tableData2 = datas.waybillItemInfoList || []; //货物信息
            this.$message.error(res.data.message || "导入失败");
          } else {
            setTimeout(() => {
              this.isShowYL = false;
            }, 1000);
            this.tableData = [];
            this.$message.success(res.data.message || "导入成功");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        isError: "",
        errorReason: "",
        waybillNumber: "",
        splitWaybillId: "",
        outgoingNumber: "",
        allCarrierWeigh: "",
        allCarrierVolume: "",
        allCarrierCount: "",
        formulaWaybillFeeMethod: "",
        formulaWaybillFeeMethodKey: "",
        unitPrice: "",
        settlementMethod: "",
        settlementMethodConfDictId: "",
        formulaBillingWeight: "",
        formulaBillingWeightId: "",
        basicFreight: "",
        sendFee: "",
        allOtherFee: "",
        carrierAttribute: "",
        carrierAttributeConfDictId: "",
        carrierName: "",
        carrierId: "",
        carrierPhone: "",
        carrierDept: "",
        carrierDeptId: "",
        remarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1(formName) {
      let arrs = [this.dialogForm1];
      this.$API
        .importOutgoingCheckV4({
          outgoingList: arrs,
          // waybillItemInfoList: this.tableData2,
        })
        .then((res) => {
          let datas = JSON.parse(JSON.stringify(this.tableData));
          datas[this.idx1] = res.data.result.outgoingList[0];
          this.isShowDialog1 = false;
          this.$nextTick(() => {
            this.tableData = datas;
            this.$refs.mytable.doLayout();
          });
        })
        .catch(() => {});
    },


    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      var otherHeight = btnListHeight + 180; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
  },
};
</script>
<style scoped lang='less'>
@borderd7: #d7d7d7;
.tipimport {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .rowRight {
    display: flex;
    align-items: center;
  }
}
.errorClaaa {
  color: #f00;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tablerTitle {
  // width: 90%;
  height: 30px;
  line-height: 30px;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: px solid #fff;
  font-weight: bold;
  margin: 16px 0;
}

.diaForm {
  /deep/ .el-select {
    width: 100%;
  }
}
</style>